import {
  InsufficientPermissionsText,
  InsufficientPermissionsTextHeader,
  InsufficientPermissionsTextRegular,
  InsufficientPermissionsTextButtons,
  InsufficientPermissionsTop,
  InsufficientPermissionsWrap,
  InsufficientPermissionsLogo,
} from './styles';
import Footer from '../Footer/Footer';
import { ButtonTypes } from '@common/components/Button/types';
import { Button } from '@common/components';
import { serviceDeskEmail } from '@common/constants';
import { useLogoutUser } from '@common/auth/useOidcAuthentication';

export const InsufficientPermissionsInfo = () => {
  const { logoutUser } = useLogoutUser();

  const handleLogout = () => {
    logoutUser();
  };

  return (
    <InsufficientPermissionsWrap>
      <InsufficientPermissionsTop>
        <InsufficientPermissionsLogo src="/publisherLogo.png" />
        <InsufficientPermissionsText>
          <InsufficientPermissionsTextHeader>Sorry to say, but...</InsufficientPermissionsTextHeader>
          <InsufficientPermissionsTextRegular>
            <p>
              <strong>You have insufficient permissions to access emc publisher.</strong>
            </p>
            <p>
              Please contact the service desk at <strong>{serviceDeskEmail}</strong>
              <br />
              or call us on 01372 371 44
            </p>
          </InsufficientPermissionsTextRegular>
        </InsufficientPermissionsText>
        <InsufficientPermissionsTextButtons>
          <Button text="Log In" type={ButtonTypes.SUCCESS} onClick={handleLogout} />
        </InsufficientPermissionsTextButtons>
      </InsufficientPermissionsTop>
      <Footer hideLinks={false} />
    </InsufficientPermissionsWrap>
  );
};
